// The price formula, for live readouts in the editors. A copy of
// server/lib/pricing.js — the server's number is the one saved and charged,
// this only shows the person typing what it will be.
//
// Rates are the defaults the server uses. If they are changed in the server's
// environment, change them here too, or the readout will be a few cents off
// what the customer is actually asked for.
export const RATES = { platformPct: 10, cardPct: 2.9, cardFixed: 0.30 };

const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// A vendor's price → what the customer pays, and where it goes.
export function vendorSplit(vendorPrice, rates = RATES) {
  const vendor = round2(vendorPrice);
  if (vendor <= 0) return { vendorPrice: 0, clientTotal: 0, platformFee: 0, processingFee: 0 };
  const clientTotal = round2((vendor + rates.cardFixed) / (1 - rates.platformPct / 100 - rates.cardPct / 100));
  const platformFee = round2(clientTotal * rates.platformPct / 100);
  return { vendorPrice: vendor, clientTotal, platformFee, processingFee: round2(clientTotal - vendor - platformFee) };
}

// QPS's own price with the card fee built in.
export function withCardFee(amount, rates = RATES) {
  const base = round2(amount);
  if (base <= 0) return base;
  return round2((base + rates.cardFixed) / (1 - rates.cardPct / 100));
}
